import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer>
      <Container>
        <Row>
          <Col className='text-center py-3'>
            <p>
              FOFOG &copy; {currentYear} · <Link to='/over-ons'>Over Ons</Link> · <Link to='/privacy'>Privacy</Link>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer